<script>
  import {
    VTabsSlider
  } from 'vuetify/lib'
  export default {
    name: 'wh-tabs-slider',
    extends: VTabsSlider
  };
</script>